import { useTranslation } from "react-i18next";
import { Card } from "../planning/components/Card.js";
import { useLanguagePreference } from "src/common/utils/hooks/useLanguagePreference.js";
import { LANGUAGES } from "src/common/utils/i18n.js";
import { LanguageSelector } from "molecules/languageSelector/LanguageSelector";

export const ProfilePreferences = () => {
	const { t } = useTranslation();
	const { language, changeLanguage } = useLanguagePreference();

	return (
		<Card>
			<div className="p-6">
				<div className="mb-2 font-medium text-gray-700 text-sm">
					{t("Language")}
				</div>
				<LanguageSelector
					languages={LANGUAGES}
					value={language}
					onChange={changeLanguage}
				/>
			</div>
		</Card>
	);
};
